import wx from 'weixin-js-sdk';
import axios from 'axios';
import { onMounted, ref, onUnmounted } from 'vue';
import gsap from 'gsap';
import { enterPage } from '@/assets/js/enterPage.js'; // 引入外部的 enterPage 方法
import { leavePage } from '@/assets/js/leavePage.js'; // 引入外部的 leavePage 方法
import { Observer } from 'gsap/Observer';
import playingIcon from '@/assets/music/playing_1.svg';
import pausedIcon from '@/assets/music/paused_18.svg';
import musicFile from '@/assets/music/music.mp3';
import beijingImage from '@/assets/v2/page1/beijing.webp';
import loadingSvg from '@/assets/loading/loadsvg.svg';
import PageOne from './components/Page1.vue';
import PageTwo from './components/Page2.vue';
import PageThree from './components/Page3.vue';
import PageThree1 from './components/Page3-1.vue';
import PageFour from './components/Page4.vue';
import PageFour2 from './components/Page4-2.vue';
import PageFour3 from './components/Page4-3.vue';
import PageFour4 from './components/Page4-4.vue';
import PageFour51 from './components/Page5-1.vue';
import PageFour511 from './components/Page5-1-1.vue';
import PageFour512 from './components/Page5-1-2.vue';
import PageFour513 from './components/Page5-1-3.vue';
import PageFour514 from './components/Page5-1-4.vue';
import PageFour52 from './components/Page5-2.vue';
import PageFour53 from './components/Page5-3.vue';
import PageFour54 from './components/Page5-4.vue';
import PageFour55 from './components/Page5-5.vue';
import PageFour56 from './components/Page5-6.vue';
import PageFour57 from './components/Page5-7.vue';
import PageFour58 from './components/Page5-8.vue';
import PageFour59 from './components/Page5-9.vue';
function noPullDown(selector) {
  //禁止页面拖动
  document.querySelector('body').addEventListener('touchmove', function (e) {
    console.log('禁止下拉出现网页来源信息');
    if (!selector) {
      e.preventDefault();
    } else {
      // 如果需要部分区域可以滑动，则需传入需要滑动地方的类名
      if (!document.querySelector(selector).contains(e.target)) {
        e.preventDefault();
      }
    }
  }, {
    passive: false
  });
}
noPullDown();
gsap.registerPlugin(Observer);
export default {
  name: 'PageScroller',
  components: {
    PageTwo,
    PageOne,
    PageThree,
    PageThree1,
    PageFour,
    PageFour2,
    PageFour3,
    PageFour4,
    PageFour51,
    PageFour511,
    PageFour512,
    PageFour513,
    PageFour514,
    PageFour52,
    PageFour53,
    PageFour54,
    PageFour55,
    PageFour56,
    PageFour57,
    PageFour58,
    PageFour59
  },
  data() {
    return {
      isPlaying: false,
      audio: null,
      playingIcon,
      pausedIcon,
      musicFile,
      isLoading: true,
      // 正在加载
      isScrolling: false,
      // 滚动状态
      currentPage: 0,
      // 当前页码
      totalPages: 21,
      // 总页数
      touchStartY: 0,
      // 触摸起始位置
      container: null,
      // 滚动容器引用
      observer: null,
      // GSAP Observer 实例
      pages: null,
      // 页面元素引用
      pageHeight: window.innerHeight,
      // 页面高度
      loadingSvg,
      loadProgress: 0,
      // 加载进度
      manuallyPaused: false // 是否手动暂停音乐
    };
  },
  setup() {
    onMounted(() => {});

    // return { currentPage };
  },
  methods: {
    setupAudio() {
      if (!this.audio) {
        this.audio = new Audio(musicFile);
        this.audio.loop = true;
        this.audio.addEventListener('play', () => this.isPlaying = true);
        this.audio.addEventListener('pause', () => this.isPlaying = false);
      }
    },
    toggleMusic() {
      this.setupAudio(); // 确保点击时初始化
      if (this.isPlaying) {
        this.audio.pause();
        this.manuallyPaused = true; // 标记为手动暂停
      } else {
        this.audio.play().catch(e => console.log("播放失败:", e));
        this.manuallyPaused = false; // 重置手动暂停标记
      }
    },
    handleGoHome() {
      //滑动到第一页
      console.log('goHome');
      this.scrollToPage(0); // 直接调用已有滚动方法
    },
    isValidIndex(index) {
      return index >= 0 && index < this.totalPages;
    },
    scrollToPage(newIndex) {
      if (!this.isValidIndex(newIndex) || this.isScrolling) return;

      // 防止频繁触发滚动，添加冷却时间控制
      this.isScrolling = true;

      // 执行离开动画和进入动画
      leavePage(this.pages, this.currentPage);
      enterPage(this.pages, newIndex);
      gsap.to(this.container, {
        scrollTop: newIndex * this.pageHeight,
        duration: 0.7,
        ease: "power2.inOut",
        onComplete: () => {
          this.currentPage = newIndex;
          this.isScrolling = false;
        }
      });

      // 设置 0.5 秒的冷却时间，防止快速连续滚动
      setTimeout(() => {
        this.isScrolling = false;
      }, 200); // 500 毫秒，即 0.5 秒后，允许再次滚动
    },
    preloadImages(imageList) {
      const total = imageList.length;
      let loaded = 0;
      const updateProgress = () => {
        this.loadProgress = Math.round(loaded / total * 100);
      };
      const promises = imageList.map(src => {
        return new Promise(resolve => {
          const img = new Image();
          img.src = src;
          img.onload = () => {
            loaded++;
            updateProgress();
            resolve();
          };
          img.onerror = () => {
            loaded++;
            updateProgress();
            resolve();
          };
        });
      });
      return Promise.all(promises);
    },
    getWxConfig() {
      // 获取当前页面URL作为参数传递给后端
      const currentUrl = encodeURIComponent(window.location.href.split('#')[0]);
      axios.get(`/api/api/wechat/jsconfig`, {
        params: {
          url: currentUrl
        }
      }).then(res => {
        console.log('获取微信配置成功:', res.data);
        console.log("res.data.appId", res.data.data.appId);
        if (res.data.code === 0) {
          // 配置微信JS-SDK
          wx.config({
            debug: false,
            appId: res.data.data.appId,
            timestamp: res.data.data.timestamp,
            nonceStr: res.data.data.nonceStr,
            signature: res.data.data.signature,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
          });
          console.log('wx.config', wx.config);
          // 配置成功后初始化分享
          wx.ready(() => {
            var shareData = {
              title: "132㎡青年置业理想家",
              desc: "明星三房，主城置业优选！",
              link: window.location.href,
              imgUrl: "http://h5.ouncloud.com/logo-a.webp"
            };
            //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            wx.updateAppMessageShareData(shareData);
            //自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容（1.4.0）
            wx.updateTimelineShareData(shareData);
          });
          //错误了会走 这里
          wx.error(function (res) {
            console.log("微信分享错误信息", res);
          });
        } else {
          console.error('获取微信配置失败:', res.data.message);
        }
      }).catch(error => {
        console.error('请求微信配置接口失败:', error);
      });
    }
  },
  mounted() {
    this.getWxConfig();
    // 添加自动播放和交互触发逻辑
    this.setupAudio();
    // 尝试立即播放音乐
    this.audio.play().catch(e => console.log("初始自动播放失败:", e));
    const tryPlayAudio = () => {
      if (!this.isPlaying && !this.manuallyPaused) {
        this.audio.play().catch(e => console.log("自动播放失败:", e));
      }
    };

    // 监听各种用户交互事件来触发音乐播放
    document.addEventListener('click', tryPlayAudio, {
      once: true
    });
    document.addEventListener('touchstart', tryPlayAudio, {
      once: true
    });
    document.addEventListener('keydown', tryPlayAudio, {
      once: true
    });

    // 禁止图片拖动
    window.onload = function () {
      let images = document.querySelectorAll('img');
      images.forEach(img => {
        img.ondragstart = function () {
          return false;
        };
      });
    };
    this.container = document.querySelector('.scroll-container');
    this.pages = document.querySelectorAll('.page');
    // 触摸事件处理
    const handleTouch = direction => {
      const newIndex = this.currentPage + direction;
      if (this.isValidIndex(newIndex)) this.scrollToPage(newIndex);
    };

    // 统一事件处理
    const handleScroll = delta => {
      const direction = delta > 0 ? 1 : -1;
      handleTouch(-direction);
    };

    // 观察者配置
    Observer.create({
      target: this.container,
      type: 'wheel,touch,pointer',
      onChange: self => {
        // 判断是否正在滑动或按住屏幕
        if (self.isTouching || self.isPointerDown) return;

        // 等待滑动停止后再翻页
        if (!this.isScrolling && Math.abs(self.deltaY) > 0) {
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(() => {
            handleScroll(self.deltaY); // 根据滑动的 Y 轴变化来翻页
          }, 200); // 延迟 200ms 判断滑动停止
        }
      }
    });

    // 触摸事件处理
    this.container.addEventListener('touchstart', e => {
      this.touchStartY = e.touches[0].clientY;
    });
    this.container.addEventListener('touchend', e => {
      if (this.isScrolling) return;
      const touchEndY = e.changedTouches[0].clientY;
      const delta = this.touchStartY - touchEndY;
      if (Math.abs(delta) > 50) {
        handleTouch(delta > 0 ? 1 : -1);
      }
    });

    // 键盘事件处理
    const handleKeydown = e => {
      if (this.isScrolling) return;
      if (e.key === 'ArrowUp') handleTouch(1);
      if (e.key === 'ArrowDown') handleTouch(-1);
    };
    window.addEventListener('keydown', handleKeydown);

    // 初始化第一页动画
    enterPage(this.pages, 0);
    onUnmounted(() => {
      window.removeEventListener('keydown', handleKeydown);
    });
    this.setupAudio();
    if (!this.audio) {
      this.audio = new Audio(this.musicFile);
      this.audio.loop = true;
    }
    this.audio.addEventListener('play', () => {
      this.isPlaying = true;
    });
    const imagesToLoad = [beijingImage, playingIcon, pausedIcon, musicFile, loadingSvg];
    this.preloadImages(imagesToLoad).then(() => {
      this.isLoading = false; // 加载完成
      this.loadProgress = 100; // 设置加载进度为100%
      // 图片加载完成后再次尝试播放音乐
      if (!this.isPlaying && !this.manuallyPaused) {
        this.audio.play().catch(e => console.log("加载完成后自动播放失败:", e));
      }
    }).catch(error => {
      console.error('Error loading images:', error);
      this.isLoading = false; // 即使加载失败也隐藏加载动画
    });
    // this.$refs.audio.play();
  }
};